export function getModalPortalHost(root: Document = document): HTMLElement {
  return root.getElementById('root') ?? root.body;
}
